import { primitiveColors, colors } from './colors';

import { radius } from './radius';

export const themeConfigAuth = {
    components: {
        Input: {
            activeBorderColor: primitiveColors.pink,
            hoverBorderColor: primitiveColors.pink,
        },
        Button: {
            colorPrimary: primitiveColors.main,
            colorPrimaryHover: primitiveColors.mainHover,
            colorPrimaryActive: primitiveColors.mainActive,
            colorPrimaryBorder: 'transparent',
            boxShadow: 'none',
            borderRadius: radius.md,
            defaultHoverBg: primitiveColors.hoverBg,
            defaultActiveBg: primitiveColors.activeBg,
            colorText: colors.white,
            colorTextDisabled: primitiveColors.gray200,
            colorBgContainerDisabled: primitiveColors.disabledBg,
            borderColorDisabled: 'transparent',
        },
    },
};
